namespace Ir.Components.Workbook.Widgets.PivotWidget {
    interface IViewModel {
        config: WorkbookConfig;
        isMetricRow: KnockoutComputed<boolean>;

        dispose: Function;
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        let self = this;
        let reportWidget: PivotWidget = params.widget

        self.config = params.config as WorkbookConfig;
        self.isMetricRow = ko.computed(() => {
            return reportWidget.itemConfig.pivotLayout() === PivotLayoutEnum.Vertical;
        });
        ;
        reportWidget.set$ReportContent(componentInfo.element);
        reportWidget.setup();

        self.dispose = ResizeService.createResizeObserverForComponent(componentInfo.element, function () { reportWidget.repaint(); }, true);
    }
}